import { createElement, Fragment, useMemo } from "react";
import { useContextLocalization } from "@/app/module/localization/index";
import { Text, TextProps } from "@/base/components/index";

export type LocalizationTextProps = {
  value: string;
  templateData?: any;
};

export const LocalizationText = ({
  value,
  templateData,
  hasTextCmp = false,
  ...props
}: LocalizationTextProps & TextProps & { hasTextCmp?: boolean }) => {
  const { getLocalizationValue } = useContextLocalization();
  const localizationText = getLocalizationValue(value);

  const style = useMemo(() => ({ color: "inherit" }), []);

  if (!localizationText) {
    return hasTextCmp ? (
      <Text style={style} {...props}>
        {value}
      </Text>
    ) : (
      value
    );
  }

  if (localizationText && !templateData) {
    return hasTextCmp ? (
      <Text style={style} {...props}>
        {localizationText}
      </Text>
    ) : (
      localizationText
    );
  }

  const result: any = [];
  const templateMatcher = /\$\{([a-zA-Z0-9_.-]+)\}/g;
  let lastIndex = 0;
  let templateIndex = 0;

  for (const match of localizationText.matchAll(templateMatcher)) {
    const matchIndex = match.index ?? 0;
    const [token, key] = match;

    if (matchIndex > lastIndex) {
      result.push(localizationText.slice(lastIndex, matchIndex));
    }

    const templateDataItem = templateData?.[key];
    result.push(
      createElement(
        Fragment,
        { key: templateIndex },
        templateDataItem !== false && templateDataItem != null
          ? templateDataItem
          : token,
      ),
    );

    templateIndex += 1;
    lastIndex = matchIndex + token.length;
  }

  if (lastIndex < localizationText.length) {
    result.push(localizationText.slice(lastIndex));
  }

  return hasTextCmp ? (
    <Text style={style} {...props}>
      {result}
    </Text>
  ) : (
    result
  );
};
